import { render, staticRenderFns } from "./k-video-viewer.vue?vue&type=template&id=03d487e6&lang=pug&"
import script from "./k-video-viewer.vue?vue&type=script&lang=js&"
export * from "./k-video-viewer.vue?vue&type=script&lang=js&"
import style0 from "./k-video-viewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d487e6')) {
      api.createRecord('03d487e6', component.options)
    } else {
      api.reload('03d487e6', component.options)
    }
    module.hot.accept("./k-video-viewer.vue?vue&type=template&id=03d487e6&lang=pug&", function () {
      api.rerender('03d487e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-video-viewer.vue"
export default component.exports